// extracted by mini-css-extract-plugin
module.exports = {"bar":"index_bar__XFPOZ","withdrawBtn":"index_withdrawBtn__AG79r"};